import React, { Component } from 'react'

import FileList from './List'

const FileSection = props => {
  const {
    files,
    onDownload,
    onPreview,
  } = props

  return (
      <FileList
        onPreview={onPreview}
        onDownload={onDownload}
        files={files}
      />
  )
}

export default FileSection
